"use client";

import { useRequestMeRelatedAccounts } from "../requests/useRequestMeRelatedAccounts";

export const useHasParentAccount = (): boolean => {
  const { data } = useRequestMeRelatedAccounts();
  return data?.some((account) => !account.is_kid) ?? false;
};
